import {gql} from '@apollo/client';

export const INSTALLED_EXTENSION_DEFINITIONS_QUERY = gql`
  query InstalledExtensionDefinitionsQuery($extensionType: ExtensionType!)
  @skipAudit
  @engComponent(name: EXTENSIONS) {
    installedExtensionDefinitions(extensionType: $extensionType) {
      hasAuditableInstallationRows
      items {
        id
        installationId
        installApprovalRequired
        installApprovalText
        displayName
        iconUrl
        isOwnedByBenchling
        tags
        tagLine
        description
        extensionType
        createdAt
        modifiedAt
        provider {
          name
          url
        }
        links {
          documentation {
            url
            text
          }
          policy {
            url
            text
          }
        }
        latestVersion {
          id
          versionId
          description
          mcpProperties {
            serverUrl
            requiresManualOauthSetup
            urlParams {
              key
              label
              description
              options
            }
          }
        }
        labels {
          key
          value
          displayName
        }
      }
    }
    extensionLabelSpecs(extensionType: $extensionType) {
      key
      displayName
      placement
    }
  }
`;
